import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import FirmographicQuestions from "./FirmographicQuestions";
import ConjointQuestions from "./ConjointQuestions";
import GaborGrangerQuestions from "./GaborGrangerQuestions";
import VanWestendorpQuestions from "./VanWestendorpQuestions";

import { answerSurvey } from "../../actions/surveyActions";

const Survey = ({ surveyLink = "test", type = "survey" }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [page, setPage] = useState(0);

    // Access state from redux
    const survey = useSelector(state => type === 'test' ? state.survey.test : state.survey.survey)
    
    // const componentsList = Object.keys(survey?.surveyDesign || {}).filter(key => survey[key] !== null);
    const componentsList = Object.keys(survey?.surveyDesign || {}).filter(key => survey?.surveyDesign[key] !== null);

    const formActions = () => {
        return (
            <React.Fragment>
                <Button variant="contained" size="small" type="submit" sx={{ mt: 2 }}>Next</Button>
            </React.Fragment>
        )
    }

    useEffect(() => {
        if (!survey.surveyCompleted && survey.stepCompleted) {
            setPage(componentsList.indexOf(survey.stepCompleted) + 1)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [survey.stepCompleted])

    const actionConjoint = (conjointData) => {
        const handleNext = () => {
            // Dispatch the action with `conjointData`
            if (type === "survey") {
                dispatch(answerSurvey(surveyLink, "conjoint", conjointData));
            }
            setPage(page + 1);
        };

        return (
            <Button variant="contained" size="small" onClick={handleNext}>
                Next
            </Button>
        );
    };

    const actionGaborGranger = (gaborGrangerData) => {
        const handleNext = () => {
            // Dispatch the action with `gaborGrangerData`
            if (type === "survey") {
                dispatch(answerSurvey(surveyLink, "gabor_granger", gaborGrangerData));
            }
            setPage(page + 1);
        };

        return (
            <Button variant="contained" size="small" onClick={handleNext}>
                Next
            </Button>
        );
    };

    const onSubmitFirmographic = (values) => {
        setPage(page + 1)

        if (type === "survey") {
            dispatch(answerSurvey(surveyLink, "firmographic", values))
        }

        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitVanWestendorp = (values) => {
        setPage(page + 1)

        if (type === "survey") {
            dispatch(answerSurvey(surveyLink, "van_westendorp", values))
        }

        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    }

    return (
        <Box sx={{ height: '80vh', display: 'flex', flexDirection: 'column' }}>
            {survey.status === 'created' ?
                <Box>This survey has not been started yet. Please check back again soon.</Box>
                : null}
            {survey.status === 'started' && componentsList[page] === 'firmographic' && survey.surveyDesign.firmographic && !survey.surveyCompleted ?
                <FirmographicQuestions
                    respondentId={survey.surveyDesign?.firmographic.respondent_id}
                    firmographic={survey.surveyDesign.firmographic}
                    formActions={formActions}
                    onSubmit={onSubmitFirmographic}
                />
                : null}
            {survey.status === 'started' && componentsList[page] === 'conjoint' && survey.surveyDesign.conjoint && !survey.surveyCompleted ?
                <ConjointQuestions
                    respondentId={survey.surveyDesign?.conjoint.respondent_id}
                    surveyLink={surveyLink}
                    type={type}
                    conjoint={survey.surveyDesign.conjoint}
                    action={actionConjoint}
                />
                : null}
            {survey.status === 'started' && componentsList[page] === 'gabor_granger' && survey.surveyDesign.gabor_granger && !survey.surveyCompleted ?
                <GaborGrangerQuestions
                    respondentId={survey.surveyDesign?.gabor_granger.respondent_id}
                    type={type}
                    gaborGranger={survey.surveyDesign.gabor_granger}
                    action={actionGaborGranger}
                />
                : null}
            {survey.status === 'started' && componentsList[page] === 'van_westendorp' && survey.surveyDesign.van_westendorp && !survey.surveyCompleted ?
                <VanWestendorpQuestions
                    respondentId={survey.surveyDesign?.van_westendorp.respondent_id}
                    vanWestendorp={survey.surveyDesign.van_westendorp}
                    formActions={formActions}
                    onSubmit={onSubmitVanWestendorp}
                />
                : null}
            {(page === componentsList.length || survey.surveyCompleted) && type === 'survey' ?
                <Box>Thank you! The survey is completed.</Box>
                : null}
            {page === componentsList.length && type === 'test' ?
                <Box>Was the Survey as you expected? Press the close button in the top right corner to get back.</Box>
                : null}
        </Box>
    )
}

export default Survey